import React, {Component} from "react";
import SVGIcon from "../svg/SVGIcon";

import "./StatsItem.css";

class StatsItem extends Component {

  render() {
    const {title,subtitle,icon} = this.props;
    return (
      <div className="fow-stats-item">
        <div className="fow-stats-item-icon">
          <SVGIcon stroke="#051C2C" name={icon} />
        </div>
        <div className="fow-stats-item-data">
          <h4 className="fow-stats-item-title fow-font-title fow-font-size-lg">{title}</h4>
          <p className="fow-stats-item-subtitle fow-font-text fow-font-size-xs">{subtitle}</p>
        </div>
      </div>
    );
  }
}

export default StatsItem;
